import styled from "@emotion/styled";
import { BASE_GUTTER_SPACE, FONTS, BRAND_PRIMARY_COLOR, COLORS } from "shared/styles/base";
import { truncate } from "shared/styles/mixin";

export const Separator = styled.p<{ showBorder: boolean }>`
    ${({ showBorder }) => showBorder && `border-bottom: 1px solid rgba(0,0,0,0.24);`}
    margin: 0 0 16px 0;
`;

export const Greeting = styled.div`
    margin-bottom: ${BASE_GUTTER_SPACE}px;
    color: ${COLORS.BLACK_100};
    font: 500 1rem/1.5 ${FONTS.CERA};
    letter-spacing: 0.2px;

    ${truncate}
`;

export const Info = styled.p`
    margin: 0 0 ${BASE_GUTTER_SPACE}px 0;
    font: 400 0.8571rem/1.43 ${FONTS.CERA};
    color: ${COLORS.BLACK_64};
    letter-spacing: 0.5px;

    ${truncate}
`;

export const Notification = styled.p`
    border: 1px solid ${COLORS.BLACK_16};
    height: 36px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 ${BASE_GUTTER_SPACE}px 0;
    font: 500 0.8571rem/1 ${FONTS.CERA};
    letter-spacing: 0.2px;
    color: ${BRAND_PRIMARY_COLOR};
    cursor: pointer;
    &:hover {
        background: ${COLORS.BLACK_16};
    }
`;
